// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_hide_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Hide filters`
};

const el_hide_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Απόκρυψη φίλτρων`
};

const ru_hide_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Скрыть фильтры`
};

const he_hide_filters = /** @type {(inputs: {}) => string} */ () => {
	return `הסתר מסננים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hide_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hide_filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("hide_filters", locale)
	if (locale === "en") return en_hide_filters(inputs)
	if (locale === "el") return el_hide_filters(inputs)
	if (locale === "ru") return ru_hide_filters(inputs)
	if (locale === "he") return he_hide_filters(inputs)
	return "hide_filters"
};